import { CommonHelper } from "../../react-core/Helpers/CommonHelper";
import { HierarchyLevelName } from "../../Wrap/Constants/Enums/HierarchyLevelName";
import { SideMenu } from "../../Wrap/Constants/Enums/Menu/SideMenu";
import { InvestorType } from "../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { SubaccountSideMenuMap } from "../Dashboard/Components/CustomNavigation/Entities/SubaccountSideMenuMap";
import { IActionMenuParamsModel } from "../Dashboard/Components/CustomNavigation/IParameterModel";
import { AccountRoleStore, ClientAccountStore } from "../Dashboard/Stroes/Variable";
import { HierarchyIdHelper } from "../Shared/Common/HierarchyIdHelper";
import { getQueryParameters } from "../Shared/Wizards/Entities/QueryParametersHelper";

const ACTION_MENU_TOKEN = "action_menu_params";

export const setActionMenuParams = (urlParams: IActionMenuParamsModel) => {
    localStorage.setItem(ACTION_MENU_TOKEN, JSON.stringify(urlParams));
};

export const getActionMenuParams = (): IActionMenuParamsModel => {
    const urlParams: IActionMenuParamsModel = {
        headaccounthierarchyId: JSON.parse(localStorage.getItem(ACTION_MENU_TOKEN))?.headaccounthierarchyId ? JSON.parse(localStorage.getItem(ACTION_MENU_TOKEN)).headaccounthierarchyId : null,
        subaccountHierarchyId: JSON.parse(localStorage.getItem(ACTION_MENU_TOKEN))?.subaccountHierarchyId ? JSON.parse(localStorage.getItem(ACTION_MENU_TOKEN)).subaccountHierarchyId : null,
        levelHierarchyId: JSON.parse(localStorage.getItem(ACTION_MENU_TOKEN))?.levelHierarchyId ? JSON.parse(localStorage.getItem(ACTION_MENU_TOKEN)).levelHierarchyId : null,
        SideMenu: JSON.parse(localStorage.getItem(ACTION_MENU_TOKEN))?.SideMenu ? JSON.parse(localStorage.getItem(ACTION_MENU_TOKEN)).SideMenu : SideMenu.Portfolio,
    };
    return urlParams;
};

export const clearActionMenuParams = () => {
    localStorage.removeItem(ACTION_MENU_TOKEN);
};

export const defaultActionMenuParams = (): IActionMenuParamsModel => {
    const accountId: string = getQueryParameters()["claccountid"];

    if (CommonHelper.isNullOrEmpty(accountId)) {
        return {
            headaccounthierarchyId: null,
            subaccountHierarchyId: null,
            levelHierarchyId: null,
            SideMenu: SideMenu.Dashboard,
        };
    }
    const isSubaccount = accountId.includes("-");
    const clientAccount = ClientAccountStore.getClientAccountInfo();
    const subAccount = (clientAccount.SubAccounts || []).find((ele) => ele.ClAccountId == accountId);
    const customerId = (AccountRoleStore.getAccountRoles() || []).find((ele) => ele.IsPrimary)?.Customer?.CustomerId;
    return {
        headaccounthierarchyId: clientAccount?.HierarchyId,
        subaccountHierarchyId: isSubaccount ? subAccount?.HierarchyId : null,
        levelHierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId),
        SideMenu: isSubaccount
            ? SubaccountSideMenuMap.getSubMenuBySubAccountType(subAccount?.SubAccountType)
            : clientAccount.InvestorType == InvestorType.Consolidated
            ? SideMenu.ConsolidatedAccount
            : SideMenu.Portfolio,
    };
};

export const getParams = (): IActionMenuParamsModel => {
    if (getActionMenuParams()) {return getActionMenuParams();}
    return defaultActionMenuParams();
};
